import { AwmsState } from './types';
import { getActiveYear } from '#server/utils/date-utils';

export const initialiseAwms = (): AwmsState => {
  return {
    activeYear: getActiveYear(),
    selectedCampusId: 0,
    selectedSchoolId: 0,
    selectedStudyPeriodId: 0,
    selectedDisciplineId: 0,
    selectedEmpStatusAbbr: [],
    columnFilters: {},
    searchFilters: {},
    selectedStaff: {},
    activeSheet: null,
    lastUwId: 0,
  };
};

export const initialState: AwmsState = initialiseAwms();
